export default {
  deep: "DEEP",
  search: "Search...",
  roles: {
    admin: "Admin",
    controlCenter: "Control Center",
  },
};
